import { Header } from 'semantic-ui-react';
import { format } from 'date-fns';

import { useProjectContext } from '~/hooks';

import BidForm from './BidForm';
import { ReactComponent as ChecklistComplete } from '~/assets/checklist-complete.svg';


import './styles.scss';

export default function InvestorBidding() {

  const { project, id, fetchProject, projectState } = useProjectContext();

  let formattedDeadline = null;
  if (project.bidDeadline) {
    // Correctly parse only the date portion without applying timezone shifting.
    const dateStr = typeof project.bidDeadline === 'string' ? project.bidDeadline.split('T')[0] : '';
    if (dateStr) {
      // Parse date as if it is "YYYY-MM-DD" local (not UTC), so it won't convert to a previous day.
      const [year, month, day] = dateStr.split('-').map(Number);
      const deadlineDate = new Date(year, month - 1, day); // JS months are 0-based
      if (!isNaN(deadlineDate.getTime())) {
        formattedDeadline = format(deadlineDate, 'MMM d');
      }
    }
  }

  let headerText: any = 'Submit your non-binding bid ' + (formattedDeadline ? 'by ' + formattedDeadline : '');
  if (project?.projectBids?.length) {
    headerText = <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}><ChecklistComplete /> Your non-binding bid has been submitted!</div>;
  }

  return (
    <div className="card">
      <Header as="h2" style={{paddingBottom: '12px'}}>{headerText}</Header>
      <BidForm
        project={project}
        id={id}
        fetchProject={fetchProject}
        projectState={projectState}
      />

      {/* <Header as="h5">Bid History</Header>
      <BidHistory project={project} /> */}
    </div>
  );
}